import React from 'react';
import * as Yup from 'yup';
import { withFormik, Field } from 'formik';
import { Form, Button } from 'semantic-ui-react';
import { withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { get } from 'lodash';

import { HHInput } from './fields';
import { FORM_NAME } from '../forms/formConstant';
import { requestResetPassword } from '../actions';

const formikEnhancer = withFormik({
  validationSchema: ({ translate }) =>
    Yup.object().shape({
      email: Yup.string()
        .email(translate('form.error.string.email'))
        .required(translate('form.error.mixed.required'))
    }),
  mapPropsToValues: () => ({ email: '' }),
  handleSubmit: (values, { props, setSubmitting, setStatus }) => {
    props.requestResetPassword(values).then(() => {
      setSubmitting(false);
      setStatus({ sent: true });
    });
  },
  displayName: FORM_NAME.NEW_PASSWORD_FORM
});

const RequestResetPasswordForm = props => {
  const {
    handleSubmit,
    isSubmitting,
    translate,
    status
  } = props;

  const sent = get(status, 'sent');

  return (
    <Form inverted onSubmit={handleSubmit}>
      <Form.Field>
        <label htmlFor='email'>{translate('form.label.email')}</label>
        <Field
          name='email'
          component={HHInput}
          otherProps={{
            id: 'email',
            className: 'g-rounded',
            placeholder: translate('form.placeholder.email'),
            type: 'email'
          }}
        />
      </Form.Field>
      <Button
        primary
        fluid
        disabled={isSubmitting || sent}
        loading={isSubmitting}
        className='g-rounded g-gradient text-uppercase'
        type='submit'
        size='big'
      >
        {translate('form.submitBtn.resetPassword')}
      </Button>
    </Form>
  );
};

export default compose(
  withLocalize,
  connect(null, { requestResetPassword }),
  formikEnhancer
)(RequestResetPasswordForm);



// WEBPACK FOOTER //
// ./src/components/forms/requestResetPasswordForm.js